export const uk = {
    emptyPayer: 'Выберите плательщика',
    emptyPaymentMethod: 'Выберите способ оплаты',
    emptySum: 'Укажите значение порога отключения',
    gteMessage: 'Порог отключения выше максимально возможного значения {maxValue} {currency}',
    lteMessage: 'Порог отключения ниже минимально возможного значения {minValue} {currency}',
    nanSum: 'Некорректное значение порога отключения'
};
